/**
 * 新统计接口，不要旧的了
 * @param {*} name
 */
export function sendStatsEvent(name) {
  // production 才上传统计
  if (process.env.NODE_ENV === 'production') {
    if (window.za && name) {
      window.za('event', name);
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/statistics/index.js